document.addEventListener('DOMContentLoaded', (e) => {
  const hash = window.location.hash.substring(1);

  const tabs = document.querySelectorAll('[data-tab]');
  const searchPanel = document.querySelector('[data-search-panel]');

  tabs.forEach((item) => {
    const href = item.href.split('#')[1];

    item.addEventListener('click', (e) => handleTabClick(e));

    if (href === hash) {
      item.dispatchEvent(new Event('click'));
    } else {
      tabs[0].dispatchEvent(new Event('click'));
    }
  });

  searchPanel.addEventListener('input', (e) => filterByName(e));
});

const handleTabClick = (e) => {
  const { tab } = e.target.dataset;

  const tabButtons = [...document.querySelectorAll('[data-tab]')];
  const tabPanes = [...document.querySelectorAll('[data-tab-content]')];
  const tabButton = tabButtons.find((item) => item.dataset.tab === tab);
  const tabPane = tabPanes.find((item) => item.dataset.tabContent === tab);

  tabButtons.forEach((item) => setInactive(item));
  tabPanes.forEach((item) => setInactive(item));

  setActive(tabButton);
  setActive(tabPane);
};

const filterByName = (e) => {
  const { value } = e.target;
  const searchTerm = value.trim().toLowerCase();
  const paymentCards = document.querySelectorAll('[data-payment-card]');

  if (!searchTerm.length) {
    paymentCards.forEach((item) => unhighlightCard(item));
    return;
  }

  paymentCards.forEach((item) => {
    unhighlightCard(item);

    const cardTitle = item.querySelector('[data-payment-card-title]');
    const cardInfo = item.querySelector('[data-payment-card-info]');
    const cardTitleContent = cardTitle.textContent.toLowerCase();
    const cardInfoContent = cardInfo.textContent.toLowerCase();

    if (cardTitleContent.includes(searchTerm) || cardInfoContent.includes(searchTerm)) {
      highlightCard(item);
    }
  });
};

const setActive = (item) => {
  item.classList.add('is_active');
}

const setInactive = (item) => {
  item.classList.remove('is_active');
}

const highlightCard = (item) => {
  item.classList.add('c_payment_card--colored');
};

const unhighlightCard = (item) => {
  item.classList.remove('c_payment_card--colored');
};
